module.exports = __webpack_public_path__ + "static/PaperworkPassagebig8bitcopy-8de57670e1514a1821605af001452504.png";